import React from 'react';
import { View, StyleSheet, Image } from '@react-pdf/renderer';
import header from "./../../images/pdf/header.png"; 

const styles = StyleSheet.create({
  header: {
    backgroundColor: "#244776",
    left: 0,
    margin: "0 0 40px 0",
    padding: "5px",
    position: "absolute",
    right: 0,
  },
  image: {
    heigh: "52px",
    marginLeft: "10px",
    width: "196px",
  }
});

const Header = () => (

  <View style={styles.header} fixed>
    <Image src={header} style={styles.image} fixed />
  </View>
);

export default Header